import dics from "@/config/dictionary";
import { assign } from "lodash";
import Vue from "vue";
import { fetchDicDataDetail } from "@/services/server/dataDictionary";

class Dictionary {
  constructor() {
    this.dics = assign({}, dics);
  }
  async init() {
    Vue.prototype.$fetchDicByField = async (field) => {
      const data = await this.fetchDicByField(field);
      return data;
    };
    Vue.prototype.$getDicByField = (field) => {
      const data = this.getDicByField(field);
      return data;
    };
  }
  async fetchDicByField(field) {
    if (!this.dics[field]) {
      try {
        const data = await fetchDicDataDetail(field);
        const dicData = data.map((v) => {
          if (field == "CallTypeList") {
            return {
              id: v.call_type_id,
              name: v.callTypeInfo.card,
            };
          } else {
            return {
              id: v.id,
              name: v.name,
            };
          }
        });
        this.dics[field] = dicData;
      } catch {
        this.dics[field] = [];
      }
    }
    return this.dics[field];
  }
  getDicByField(field) {
    if (this.dics[field] === undefined) {
      return [];
    } else {
      return this.dics[field];
    }
  }
}
export default new Dictionary();
